import notification from '../../notification'

export default {
    data() {
      return {
        agreement: {},
      }
    },
    methods: {
      createAgreement() {
        this.$vs.loading()
        const payload = {
          name: this.agreement.name,
          short_content: this.agreement.short_content,
          full_content: this.agreement.full_content,
          is_required: this.agreement.is_required,
        }
        this.$store.dispatch('agreements/createAgreement', payload)
        .then(() => {
          this.$vs.notify(notification.success('Zgoda została dodana'))
          this.closeSideBar()
        })
        .catch(error => {
          if(error.response.status === 422){
            this.formErrors =  error.response.data.errors
          } else {
            this.$vs.notify(notification.error(error.message))
          }
        })
        .finally(() => {
          this.$vs.loading.close()
        })
      },
    }
}